import { Talent } from "../talents/talentAPI";
import { TalentSectionContainer } from "../talents/talentStyled";
import TalentWorkHistory from "../workHistory/TalentWorkHistory";
import { WorkHistory } from "../workHistory/types/queries";
import { ContentKey } from "./TalentDetails";
import { TalentShiftSalaries } from "./TalentShiftSalaries";
import TalentLanguageSkills from "./account/TalentLanguageSkills";
import TalentCoverLetter from "./coverLetter/TalentCoverLetter";
import TalentEducations from "./educations/TalentEducations";
import TalentPersonalInfo from "./personalInfo/TalentPersonalInfo";
import TalentSkills from "./talentSkills/TalentSkills";
import TalentWorkTitles from "./talentWorkTitles/TalentWorkTitles";
import TalentTrainings from "./trainings/TalentTrainings";
import TalentUserAccount from "./userAccount/TalentUserAccount";
import TalentWorkRight from "./workRight/TalentWorkRight";
import PaymentAndTaxInformation from "./salaryInformation/PaymentAndTaxInformation";
import TalentDriversLicenses from "./talentCertificates/drivingLicenses/TalentDrivingLicenses";
import TalentWorkPermits from "./talentCertificates/workPermits/TalentWorkPermits";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { updateAttachmentsInLocalStorage } from "../talents/talentsSlice";
import TalentWorkingArea from "./workingArea/TalentWorkingArea";
import { TalentCV } from "./cv/TalentCV";

type Props = {
  workHistories: WorkHistory[];
  handleOpenEditModal: (content: ContentKey) => void;
  handleSelectEducation: (id: string) => void;
  talent: Talent;
};

const TalentProfileTabContent = ({
  workHistories,
  handleOpenEditModal,
}: Props) => {
  const { talentId } = useParams();
  const dispatch = useAppDispatch();

  // Update attachments in local storage when landing on the page
  useEffect(() => {
    talentId && dispatch(updateAttachmentsInLocalStorage(talentId as string));
  }, [talentId, dispatch]);

  return (
    <TalentSectionContainer>
      <TalentPersonalInfo />
      <TalentCoverLetter handleOpenEditModal={handleOpenEditModal} />
      <TalentWorkingArea />
      <TalentWorkTitles handleOpenEditModal={handleOpenEditModal} />
      <TalentShiftSalaries handleOpenEditModal={handleOpenEditModal} />
      <TalentSkills handleOpenEditModal={handleOpenEditModal} />
      <TalentWorkPermits handleOpenEditModal={handleOpenEditModal} />
      <TalentDriversLicenses handleOpenEditModal={handleOpenEditModal} />
      <TalentEducations handleOpenEditModal={handleOpenEditModal} />
      <TalentTrainings handleOpenEditModal={handleOpenEditModal} />
      <TalentLanguageSkills handleOpenEditModal={handleOpenEditModal} />
      <TalentWorkHistory
        workHistories={workHistories}
        handleOpenEditModal={handleOpenEditModal}
      />
      <TalentCV handleOpenEditModal={handleOpenEditModal} />
      <TalentWorkRight handleOpenEditModal={handleOpenEditModal} />
      <PaymentAndTaxInformation />
      <TalentUserAccount />
    </TalentSectionContainer>
  );
};

export default TalentProfileTabContent;
